import { render, staticRenderFns } from "./CreatorProfessionalRecoveryDialog.vue?vue&type=template&id=280c4cbc&scoped=true&"
import script from "./CreatorProfessionalRecoveryDialog.vue?vue&type=script&lang=js&"
export * from "./CreatorProfessionalRecoveryDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreatorProfessionalRecoveryDialog.vue?vue&type=style&index=0&id=280c4cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c4cbc",
  null
  
)

export default component.exports